var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClinicalStudyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 0C0.6775 0 0 0.6775 0 1.5V10.5C0 11.3225 0.6775 12 1.5 12H10V0H1.5ZM1.5 1H9V9H1.5C1.32915 9.00214 1.15996 9.03394 1 9.094V1.5C1 1.217 1.217 1 1.5 1ZM4.5 3V4.5H3V5.5H4.5V7H5.5V5.5H7V4.5H5.5V3H4.5ZM1.5 10H9V11H1.5C1.217 11 1 10.783 1 10.5C1 10.217 1.217 10 1.5 10Z",
    fill: "#848798"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinicalStudyIcon);
export default __webpack_public_path__ + "static/media/clinical-study-icon.3c0dc4a28624ced9cc1181181f5cca23.svg";
export { ForwardRef as ReactComponent };